<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
export default {
  mixins: [ContextMenuMixin],
  computed: {
    routeParam() {
      return { submission: this.item.id };
    },
    menu() {
      let menu = [];

      menu.push({
        label: "View",
        action: () => {
          this.goToRoute("admin.forms.submissions.show", { submission: this.item.id });
        }
      });

      if (!!this.item.can_delete) {
        menu.push({
          label: "Remove",
          action: () => {
            this.doAction("remove");
          }
        });
      }


      return menu;
    }
  }
};
</script>